// 结算系数
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style=" height: calc(100vh - -35px);">
					<vxe-grid
					show-overflow
          :stripe="true" border="default"
					height="100%"
          :row-config="{isHover: true}"
					ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
						@custom="$vxeTableUtil.customHandle">

						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button v-if="sfSettleCoefficientAdd" status="primary" class="button-sty" icon="el-icon-plus"
										@click="openEditDialog">新增</vxe-button>
								</div>
								<div class="fr">
<!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--										status="primary" plain>重置</vxe-button>-->
									<vxe-button status="warning" icon="el-icon-search" class="button-sty"
										@click="searchEvent">搜索</vxe-button>
								</div>
							</div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                        :data="requestParam" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent"
              >
                <!-- <vxe-form-item title="产品编号:" field="name">
                  <template v-slot>
                    <el-input v-model="coefficientType" size="small" clearable />
                  </template>
                </vxe-form-item> -->
                <!-- <vxe-form-item title="创建方式:" field="engineerType">
									<template v-slot>
										<el-select v-model="coefficientType" clearable>
                      <el-option label="接口" :value="0" />
                        <el-option label="手动录入" :value="1" />
                        <el-option label="批量导入" :value="2" />
										</el-select>
									</template>
								</vxe-form-item>			 -->
                <vxe-form-item title="系数类型:" field="coefficientType">
									<template v-slot>
										<el-select v-model="coefficientType" clearable>
                      <el-option label="区域系数" :value="1" />
                        <el-option label="网点星级系数" :value="2" />
                        <el-option label="满意度系数" :value="3" />
										</el-select>
									</template>

								</vxe-form-item>		
                <vxe-form-item title="时间选择:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 16vw;" v-model="createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
             
              </vxe-form>
						</template>
						<!-- 分页器 -->
						<template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue'
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import { mapGetters } from 'vuex';

export default {
  name: 'coefficient',

	components: { editView, pager },
	data() {
		return {
      createDate:'',
      getPageDataUrl: '/basic/sfSettleCoefficient/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        itemCode: "",  // 产品编码
        itemName: "",  // 产品名称
        barcode: '',  // 产品条码
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
      },
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
      coefficientType: '',
      total: 0,  // 数据总数
      vxeOption: {},
      columns:  [
        { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },

        { title: '系数类型', field: 'coefficientType', width: 100, slots: {
            default: ({ row }) => {
              if (row.coefficientType === 1) {
                return [
                  <div>
                    <span>区域系数</span>
                  </div>
                ];
              } else if (row.coefficientType == 2) {
                return [
                  <div>
                    <span>网点星级系数</span>
                  </div>
                ];
              } else if (row.coefficientType == 3) {
                return [
                  <div>
                    <span>满意度系数</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '区域结算等级', field: 'settleLevel', width: 100, slots: {
            default: ({ row }) => {
              if (row.settleLevel === 0) {
                return [
                  <div>
                    <span>默认</span>
                  </div>
                ];
              } else if (row.settleLevel == 1) {
                return [
                  <div>
                    <span>一级</span>
                  </div>
                ];
              } else if (row.settleLevel == 2) {
                return [
                  <div>
                    <span>二级</span>
                  </div>
                ];
              }else if (row.settleLevel == 3) {
                return [
                  <div>
                    <span>三级</span>
                  </div>
                ];
              }
              else if (row.settleLevel == 4) {
                return [
                  <div>
                    <span>四级</span>
                  </div>
                ];
              }
            }
          }
        },
        {
						field: 'starLevel', title: '网点星级', width: 130, slots: {
						  default: ({ row }) => {
              if (row.starLevel === 1) {
                return [
                  <div>
                    <span>一级</span>
                  </div>
                ];
              } else if (row.starLevel == 2) {
                return [
                  <div>
                    <span>二级</span>
                  </div>
                ];
              } else if (row.starLevel == 3) {
                return [
                  <div>
                    <span>三级</span>
                  </div>
                ];
              }else if (row.starLevel == 4) {
                return [
                  <div>
                    <span>四级</span>
                  </div>
                ];
              }
              else if (row.starLevel == 5) {
                return [
                  <div>
                    <span>五级</span>
                  </div>
                ];
              }
            }
						}
					},
          {
						field: 'satisfactionLevel', title: '满意度', width: 130, slots: {
						  default: ({ row }) => {
              if (row.satisfactionLevel === 1) {
                return [
                  <div class="txt-status ">
                    <span>非常满意</span>
                  </div>
                ];
              } else if (row.satisfactionLevel == 2) {
                return [
                  <div class="txt-status ">
                    <span>满意</span>
                  </div>
                ];
              } else if (row.satisfactionLevel == 3) {
                return [
                  <div class="txt-status neutral">
                    <span>一般</span>
                  </div>
                ];
              }else if (row.satisfactionLevel == 4) {
                return [
                  <div class="txt-status disable">
                    <span>不满意</span>
                  </div>
                ];
              }
              else if (row.satisfactionLevel == 5) {
                return [
                  <div class="txt-status disable">
                    <span>非常不满意</span>
                  </div>
                ];
              }
            }
						}
					},
        { title: '系数', field: 'coefficient', width: 110, },

        { title: '开始时间', field: 'beginDate', width: 100, },

        { title: '结束时间', field: 'endDate', width: 100 },
        // { title: '创建人', field: 'createBy', width: 80, },
        { width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({ row }) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-edit" />
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        },
        { title: '创建人', field: 'createBy', width: 100 },
        { title: '创建时间', field: 'createTime', width: 100 },
      ],
		};
	},
  computed:{
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created(){
      this.sfSettleCoefficientAdd = this.permissions["sfSettleCoefficientAdd"];
      this.sfSettleCoefficientEdit = this.permissions["sfSettleCoefficientEdit"];
  },
  mounted(){ 
    this.getTableData()
  },
	methods: {
    toFilterData() {
            this.searchEvent();
     },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.settleCoefficient.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.requestParam.coefficientType = this.coefficientType
      this.requestParam.createDate = this.createDate
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.coefficientType = ''
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}
</style>
